/*global google*/
import React from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const AdmLogin = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    
    // Basic user information
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [emailValue, setEmailValue] = useState(""); 
    const [designationValue, setDesignationValue] = useState("");
    const [gender, setGender] = useState('');
    const [userCodeLocal, setUserCodeLocal] = useState("");
    const [queryParams, setQueryParams] = useState(null);
    // Scheme and user type
    const [schemeValue, setSchemeValue] = useState('NA');
    const [userTypeValue, setUserTypeValue] = useState('NA');
    
    // State related (for CRM State users)
    const [stateValue, setStateValue] = useState('NA');
    const [statesData, setStatesData] = useState([]);
    
    // FMTTI related
    const [fmttiData, setFmttiData] = useState([]);
    const [fmttiValue, setFmttiValue] = useState("");
    
    // Common data
    const [designationData, setDesignationData] = useState([]);

    useEffect(() => {
        fetchDesignation();
        fetchFmttiData();
        fetchStates();
    }, [schemeValue]); // Added schemeValue to dependencies

    useEffect(() => {
      //alert(sessionStorage.getItem("userNameModel"));
        // useEffect to set defaultValue in dropdown menu
        
        if (state) {
          console.log("state$$$", state)
          setUserNameValue(state.cropSurveyCode.userName);
          setMobileValue(state.cropSurveyCode.mobile)
          setEmailValue(state.cropSurveyCode.emailId)
          setDesignationValue(state.cropSurveyCode.designationCode);
          setUserCodeLocal(state.cropSurveyCode.userCode);
          setGender(state.cropSurveyCode.gender)
        }
      }, []);
      const baseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
       const queryClient = useQueryClient();

    // ── React Query: survey data fetch ───────────────────────────────────────
    const {
        data: queryData,
        isLoading,
        error: queryError,
    } = useQuery({
        queryKey: ['surveyDetail', queryParams],
        queryFn: async () => {
            const res = await axios.post(
                `${baseUrl}/api/MT/CHCSurveyDetail`,
                queryParams,
                { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
            );
            const content = res?.data?.dataContent ?? [];
            return Array.isArray(content) ? content : [];
        },
        enabled: queryParams !== null,
        staleTime: 5 * 60 * 1000,   // 5 min tak same filters ka result cache se milega
        gcTime:    20 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
    });
    const fetchDesignation = async () => {
        const result = await axios(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/Management/commDesignation`
        );
        setDesignationData(result.data.dataContent);
      };

    const fetchFmttiData = async () => {
        try {
            const response = await axios.get(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/MT/GetFmtti`
            );
            console.log("FMTTI API response:", response.data);
            if (response.data && response.data.success && response.data.dataContent) {
                setFmttiData(response.data.dataContent);
                console.log("FMTTI data set:", response.data.dataContent);
            } else {
                console.error("Invalid FMTTI data format received");
            }
        } catch (error) {
            console.error("Error fetching FMTTI data:", error);
        }
    };
    function handleFmttiChange(value) {
        console.log("Selected FMTTI value:", value);
        setFmttiValue(value);
    }

    const fetchStates = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            const allStates = result.data.dataContent;
            
            // Update states based on scheme selection
            if (schemeValue === "2") { // For CRM scheme
                const filteredStates = allStates.filter(state => 
                    ['Delhi', 'Punjab', 'Haryana', 'Madhya Pradesh', 'Uttar Pradesh'].includes(state.stateName)
                );
                console.log("Filtered states for CRM:", filteredStates);
                setStatesData(filteredStates);
            } else { // For SMAM and other schemes
                console.log("All states:", allStates);
                setStatesData(allStates);
            }
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    function handleStateChange(value) {
        console.log("Selected State value:", value);
        setStateValue(value);
    }

    function ValidateAddUser() {
        console.log("ValidateAddUser function called");
        console.log("Current form values:", {
            schemeValue,
            userNameValue,
            mobileValue,
            emailValue,
            designationValue,
            gender,
            stateValue
        });
        
        let valid = false;

        try {
            // Scheme validation
            if(!schemeValue || schemeValue === "NA") {
                alert("Please select a Component");
                return;
            }
            
            // FMTTI scheme validation
            if (schemeValue === "1") { 
                if (!fmttiValue || fmttiValue === "NA") {
                    alert("Please select an FMTTI User Type");
                    return;
                }
            }

            // Base validations always required
            if(!userNameValue || userNameValue.trim() === "") {
                alert("Please enter a valid User Name");
                return;
            }

            // CRM scheme validation
            if (schemeValue === "2") { 
                if (!userTypeValue || userTypeValue === "NA") {
                    alert("Please select a User Type for CRM");
                    return;
                }
            }
                
            // State validation for CRM State users and SMAM users
            if (schemeValue === "3" && (!stateValue || stateValue === "NA")) {
                alert("Please select a State for SMAM");
                return;
            }

            if(!mobileValue || mobileValue.length !== 10) {
                alert("Please enter a valid 10-digit Mobile Number");
                return;
            }

            if(!designationValue || designationValue === "Choose...") {
                alert("Please select a Designation");
                return;
            }

            if(!emailValue || !emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                alert("Please enter a valid Email Address");
                return;
            }

            if(!gender) {
                alert("Please select a Gender");
                return;
            }

            valid = true;
            console.log("Validation successful, proceeding with", state ? "UpdateUser" : "AddNewUser");
            
            if(valid) {
                state ? UpdateUser() : AddNewUser();
            }
        } catch (error) {
            console.error("Error in ValidateAddUser:", error);
            alert("An error occurred during validation: " + error.message);
        }
    }
  //  alert(sessionStorage.getItem("userNameValue"));
    function AddNewUser() {
        console.log("AddNewUser function called with values:", {
            schemeValue,
            userTypeValue,
            stateValue,
            userNameValue,
            mobileValue,
            emailValue,
            designationValue,
            gender,
            fmttiValue
        });
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            console.log("Headers set:", myHeaders);

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Function to determine userTypeCode based on scheme
            const getUserTypeCode = () => {
              if (schemeValue === "1") { // FMTTI scheme
                  return "1"; // FMTTI user type
              } else if (schemeValue === "2") { // CRM scheme
                  return "2"; // Use selected user type
              }
              else if (schemeValue === "3") { // SMAM scheme
                    return "3"; // SMAM user type
              }
             
            };

            const getUserRoleCode = () => {
                if (schemeValue === "1") { // FMTTI scheme
                    return "6"; // FMTTI user type
                } else if (schemeValue === "2") { // CRM scheme
                    if (userTypeValue === "2") {
                        return "2"; // Use selected user type
                    } else if (userTypeValue === "9") {
                        return "9"; // Use selected user type
                    }
                }
                else if (schemeValue === "3") { // SMAM scheme
                    return "2"; // SMAM user type
                } 
            };

            const getUserRoleName = () => {
                if (schemeValue === "1") { // FMTTI scheme
                    return "FMTTI";
                } else if (schemeValue === "2") { // CRM scheme
                    if (userTypeValue === "2") {
                        return "CRM State";
                    } else if (userTypeValue === "9") {
                        return "CRM ICAR";
                    } 
                } else if (schemeValue === "3") { // SMAM scheme
                    return "SMAM"; // SMAM user type
                }
            };
            // Create payload
            const currentUserCode = sessionStorage.getItem("userCodeModel");
            const userCodeValue = currentUserCode && currentUserCode !== "null" && currentUserCode !== "undefined" ? Number(currentUserCode) : 1;
            
            const payload = {
                "entity": "user", // Add required entity field
                "createdOnByUC": currentDate,
                "createdByUC": userCodeValue,
                "modifiedOnByUC": currentDate,
                "modifiedByUC": userCodeValue,
                "userRoleCode": getUserRoleCode(),
                "userRoleName": getUserRoleName(),
                "userCode": userCodeValue,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": (schemeValue === "2" && userTypeValue === "2") || schemeValue === "3" ? String(stateValue) : "",
                "districtCode": "",
                "subDistrictCode": "",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": getUserTypeCode(),
                "schemeCode": "16", // Always send 16 as schemeCode
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": schemeValue === "1" ? Number(fmttiValue) : 0,
                "fmtcCode": 0,
                "atariCode": 0,
                "kvkCode": 0
            };
            
           
            const apiUrl = `${
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
            }/api/MT/Users`;
            console.log("Making API request to:", apiUrl);
            fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            })
            .then(async response => {
                console.log("Response status:", response.status);
                const text = await response.text();
                console.log("Raw API Response:", text);
                try {
                    const data = JSON.parse(text);
                    console.log("Parsed API Response:", data);
                    if (!response.ok) {
                        throw new Error(data.message || `HTTP error! status: ${response.status}`);
                    }
                    return data;
                } catch (e) {
                    console.error("Error parsing response:", e);
                    throw new Error(`Failed to parse response: ${text}`);
                }
            })
            .then(data => {
                console.log("Processed API Response:", data);
                console.log("Response success field:", data.success);
                console.log("Response message:", data.message);
                
                // Check for success - only navigate if explicitly successful
                const isSuccess = data.success === true || data.success === "true";
                
                console.log("Final success determination:", isSuccess);
                
                if (isSuccess) {
                    alert(data.message || "User created successfully!");
                    // Ensure required session storage values are set for UsrListMnT.js
                    // These should be the current logged-in user's values, not the newly created user
                    const currentUserCode = sessionStorage.getItem("userCodeModel");
                    const currentUserRole = sessionStorage.getItem("userRoleCodeModel");
                    navigate("/MNT/UsrlistMnT");
                    console.log("Current session values:", { currentUserCode, currentUserRole });
                    
                    // If we have a valid user code, use it for createdByUC
                    if (currentUserCode && currentUserCode !== "null" && currentUserCode !== "undefined") {
                        sessionStorage.setItem("createdByUCModel", currentUserCode);
                    } else {
                        // Try to get it from the newly created user response
                        const newUserCode = data.dataContent?.userCode;
                        if (newUserCode) {
                            sessionStorage.setItem("createdByUCModel", newUserCode.toString());
                            sessionStorage.setItem("userCodeModel", newUserCode.toString()); // Also set the current user code
                        } else {
                            // Fallback - use a default value that won't cause API errors
                            sessionStorage.setItem("createdByUCModel", "1");
                            sessionStorage.setItem("userCodeModel", "1");
                        }
                    }
                    
                    // Set user type code
                    if (currentUserRole && currentUserRole !== "null" && currentUserRole !== "undefined") {
                        sessionStorage.setItem("userTypeCodeModel", currentUserRole);
                    } else {
                        // Set based on the scheme being used
                        const userRoleCode = getUserRoleCode();
                        sessionStorage.setItem("userTypeCodeModel", userRoleCode);
                        sessionStorage.setItem("userRoleCodeModel", userRoleCode);
                    }
                    
                    // Set scheme code
                    sessionStorage.setItem("schemeCode", "16");
                    
                    // Set state and district codes for filtering (if available)
                    if (data.dataContent && data.dataContent.stateCode) {
                        sessionStorage.setItem("stateCodeModel", data.dataContent.stateCode.toString());
                        // Also set state name if available
                        if (data.dataContent.stateName) {
                            sessionStorage.setItem("stateNameModel", data.dataContent.stateName);
                        }
                    } else if (userTypeValue === "2" && stateValue) {
                        // For CRM State users, use the selected state code
                        sessionStorage.setItem("stateCodeModel", stateValue.toString());
                    } else {
                        // For other user types, set default "0" to avoid null values
                        sessionStorage.setItem("stateCodeModel", "0");
                    }
                    
                    if (data.dataContent && data.dataContent.districtCode) {
                        sessionStorage.setItem("districtCodeModel", data.dataContent.districtCode.toString());
                    } else {
                        // Set default "0" to avoid null values
                        sessionStorage.setItem("districtCodeModel", "0");
                    }
                    
                    console.log("Session storage after user update:", {
                        userCode: sessionStorage.getItem("userCodeModel"),
                        userRole: sessionStorage.getItem("userRoleCodeModel"),
                        stateCode: sessionStorage.getItem("stateCodeModel"),
                        districtCode: sessionStorage.getItem("districtCodeModel")
                    });
                    
                    // Additional state and district codes for filtering (avoid duplicates)
                    console.log("State codes already set above, skipping duplicate setting");
                    
                    console.log("Session storage after user creation:", {
                        userCode: sessionStorage.getItem("userCodeModel"),
                        userRole: sessionStorage.getItem("userRoleCodeModel"),
                        stateCode: sessionStorage.getItem("stateCodeModel"),
                        districtCode: sessionStorage.getItem("districtCodeModel")
                    });
                } else {
                    console.log("User creation failed or returned error, staying on current page");
                    const cleanMessage = getCleanErrorMessage(data.message);
                    alert(cleanMessage);
                    // Don't navigate - just show the error message and stay on the form
                }
            })
            .catch(error => {
                console.error("Error creating user:", error);
                const cleanMessage = getCleanErrorMessage(error.message);
                alert("Error creating user: " + cleanMessage);
            });
        } catch (error) {
            console.error("Error in AddNewUser:", error);
            alert("Error: " + error.message);
        }
    }

    function UpdateUser() {
        console.log("UpdateUser function called");
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Function to determine userTypeCode based on scheme
            const getUserTypeCode = () => {
                if (schemeValue === "1") { // FMTTI scheme
                    return "1"; // FMTTI user type
                } else if (schemeValue === "2") { // CRM scheme
                    return userTypeValue; // Return actual selected user type for CRM
                } else if (schemeValue === "3") { // SMAM scheme
                    return "3"; // SMAM user type
                }
                
            };

            const getUserRoleCode = () => {
                if (schemeValue === "1") { // FMTTI scheme
                    return "6"; // FMTTI user type
                } else if (schemeValue === "2") { // CRM scheme
                    return userTypeValue; // Return actual selected user type for CRM
                } else if (schemeValue === "3") { // SMAM scheme
                    return "2"; // SMAM user type
                }
               
            };
            
            const getUserRoleName = () => {
                if (schemeValue === "1") { // FMTTI scheme
                    return "FMTTI";
                } else if (schemeValue === "2") { // CRM scheme
                    if (userTypeValue === "2") {
                        return "CRM State";
                    } else if (userTypeValue === "9") {
                        return "CRM ICAR";
                    } 
                } else if (schemeValue === "3") { // SMAM scheme
                    return "SMAM"; // SMAM user type
                }
                
            };
            // Create payload
            const currentUserCode = sessionStorage.getItem("userCodeModel");
            const userCodeValue = currentUserCode && currentUserCode !== "null" && currentUserCode !== "undefined" ? Number(currentUserCode) : 1;
            
            const payload = {
                "entity": "user",
                "createdOnByUC": currentDate,
                "createdByUC": userCodeValue,
                "modifiedOnByUC": currentDate,
                "modifiedByUC": userCodeValue,
                "userRoleCode": getUserRoleCode(),
                "userRoleName": getUserRoleName(),
                "userCode": userCodeValue,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": mobileValue, // Setting password same as mobile for initial setup
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": (schemeValue === "2" && userTypeValue === "2") || schemeValue === "3" ? String(stateValue) : "",
                "districtCode": "0",
                "subDistrictCode": "0",
                "blockCode": "0",
                "villageCode": "0",
                "userTypeCode": getUserTypeCode(),
                "schemeCode": "16",
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": schemeValue === "1" ? Number(fmttiValue) : 0,
                "fmtcCode": 0,
                "atariCode": 0,
                "kvkCode": 0
            };
            
            console.log("API Payload for update:", payload);
            var raw2 = JSON.stringify(payload);

            var requestOptions = {
              method: "PUT",
              headers: myHeaders,
              body: raw2,
              redirect: "follow",
            };

            const apiUrl = `${
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
            }/api/MT/Users`;
            console.log("Sending API request to update user:", apiUrl);
            
            fetch(
              apiUrl,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    console.log("Response success field:", jsonResult.success);
                    console.log("Response message:", jsonResult.message);
                    
                    // Check for success - only navigate if explicitly successful
                    const isSuccess = jsonResult.success === true || jsonResult.success === "true";
                    
                    console.log("Final success determination:", isSuccess);
                    
                    if (isSuccess) {
                        alert(jsonResult.message || "User updated successfully!");
                        console.log("User updated successfully, navigating to user list");
                        // Ensure required session storage values are set for UsrListMnT.js
                        const currentUserCode = sessionStorage.getItem("userCodeModel");
                        const currentUserRole = sessionStorage.getItem("userRoleCodeModel");
                        
                        // If we have a valid user code, use it for createdByUC
                        if (currentUserCode && currentUserCode !== "null" && currentUserCode !== "undefined") {
                            sessionStorage.setItem("createdByUCModel", currentUserCode);
                        } else {
                            sessionStorage.setItem("createdByUCModel", "1");
                            sessionStorage.setItem("userCodeModel", "1");
                        }
                        
                        // Set user type code
                        if (currentUserRole && currentUserRole !== "null" && currentUserRole !== "undefined") {
                            sessionStorage.setItem("userTypeCodeModel", currentUserRole);
                        } else {
                            const userRoleCode = getUserRoleCode();
                            sessionStorage.setItem("userTypeCodeModel", userRoleCode);
                            sessionStorage.setItem("userRoleCodeModel", userRoleCode);
                        }
                        
                        sessionStorage.setItem("schemeCode", "16");
                        
                        // Set state and district codes for filtering (if available)
                        if (jsonResult.dataContent && jsonResult.dataContent.stateCode) {
                            sessionStorage.setItem("stateCodeModel", jsonResult.dataContent.stateCode.toString());
                            // Also set state name if available
                            if (jsonResult.dataContent.stateName) {
                                sessionStorage.setItem("stateNameModel", jsonResult.dataContent.stateName);
                            }
                        } else if (userTypeValue === "2" && stateValue) {
                            // For CRM State users, use the selected state code
                            sessionStorage.setItem("stateCodeModel", stateValue.toString());
                        } else {
                            // For other user types, set default "0" to avoid null values
                            sessionStorage.setItem("stateCodeModel", "0");
                        }
                        
                        if (jsonResult.dataContent && jsonResult.dataContent.districtCode) {
                            sessionStorage.setItem("districtCodeModel", jsonResult.dataContent.districtCode.toString());
                        } else {
                            // Set default "0" to avoid null values
                            sessionStorage.setItem("districtCodeModel", "0");
                        }
                        
                       
                        
                        navigate("/MNT/UsrlistMnT");
                    } else {
                        console.log("User update failed or returned error, staying on current page");
                        const cleanMessage = getCleanErrorMessage(jsonResult.message);
                        alert(cleanMessage);
                        // Don't navigate - just show the error message and stay on the form
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                alert("Error communicating with server");
              });
        } catch (error) {
            console.error("Error in UpdateUser:", error);
            alert("An error occurred while updating user. Please check console for details.");
        }
    }

    function handleMobileNumber(e) {
        const value = e.target.value;
        const valueFinal = value.replace(/\D/g, "").replace(/^[0-5]/, "");
        setMobileValue(valueFinal);
    }

    function validateMobile() {
       if (mobileValue.length === 10) {
          document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
          document.getElementById("mobilenumber").style.borderColor = "red";
        }
    }
    function validateEmail() {
        if (emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
          document.getElementById("emailid").style.borderColor = "green";
        } else {
          document.getElementById("emailid").style.borderColor = "red";
        }
    }

    function handleUserName(e) {
      const value = e.target.value;
      const localText = value.replace(/[^\w\s]/gi, "");
      console.log("Setting userName to:", localText);
      setUserNameValue(localText);
    }

    // Function to clean up error messages for better user experience
    function getCleanErrorMessage(message) {
        if (!message) return "An error occurred. Please try again.";
        
        // Clean up common error messages
        if (message.includes("Users Mobile already exist")) {
            return "Mobile number already exists. Please use a different mobile number.";
        }
        if (message.includes("Something wrong with adding Users")) {
            return "Unable to create user. Please check your information and try again.";
        }
        if (message.includes("Users Email already exist")) {
            return "Email address already exists. Please use a different email address.";
        }
        if (message.includes("Users UserName already exist")) {
            return "Username already exists. Please choose a different username.";
        }
        
        // Return the original message if no specific cleanup is needed
        return message;
    }

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt /> 
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>User Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">User Creation</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        
                                        {/* Scheme dropdown */}
                                        <div className='col-md-4'>
                                            <label className="form-label">Component Name</label><label style={{color : "red"}}>*</label>
                                            <select className='form-select' id="schemeName" onChange={(e) => setSchemeValue(e.target.value)} value={schemeValue}> 
                                                <option value={"NA"}>Choose...</option>
                                                <option value={"1"}>FMTTI</option>
                                                <option value={"2"}>CRM</option>
                                                <option value={"3"}>SMAM</option>
                                            </select>
                                        </div>
                                        
                                        {/* FMTTI dropdown - visible when FMTTI scheme is selected */}
                                        {schemeValue === "1" && (
                                            <div className='col-md-4'>
                                                <label className="form-label">FMTTI User Type</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className='form-select' 
                                                    id="fmttiDropdown" 
                                                    onChange={(e) => handleFmttiChange(e.target.value)} 
                                                    value={fmttiValue}
                                                > 
                                                    <option value={"NA"}>Choose...</option>
                                                    {fmttiData && fmttiData.length > 0 ? (
                                                        fmttiData.map((item, index) => {
                                                            const code = item.fmtticode || item.FmttiCode || item.fmttiCode || item.FMTTICODE || "";
                                                            const name = item.fmttiname || item.FmttiName || item.fmttiName || item.FMTTINAME || "";
                                                            return (
                                                                <option key={index} value={code}>
                                                                    {name}
                                                                </option>
                                                            );
                                                        })
                                                    ) : (
                                                        <option>Loading FMTTI data...</option>
                                                    )}
                                                </select>
                                            </div>
                                        )}
                                        
                                        {/* User Type dropdown - visible when CRM scheme is selected */}
                                        {schemeValue === "2" && (
                                            <div className='col-md-4'>
                                                <label className="form-label">CRM User Type</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className='form-select' 
                                                    id="userTypeDropdown" 
                                                    onChange={(e) => setUserTypeValue(e.target.value)} 
                                                    value={userTypeValue}
                                                > 
                                                    <option value={"NA"}>Choose...</option>
                                                    <option value={"2"}>State</option>
                                                    <option value={"9"}>ICAR</option>
                                                </select>
                                            </div>
                                        )}
                                        
                                        {/* State dropdown - visible when State user type is selected */}
                                        {(schemeValue === "2" && userTypeValue === "2" || schemeValue === "3") && (
                                            <div className='col-md-4'>
                                                <label className="form-label">State</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className='form-select' 
                                                    id="stateDropdown" 
                                                    onChange={(e) => handleStateChange(e.target.value)} 
                                                    value={stateValue}
                                                > 
                                                    <option value={"NA"}>Choose...</option>
                                                    {statesData && statesData.length > 0 ? (
                                                        statesData.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.stateCode}>
                                                                    {item.stateName}
                                                                </option>
                                                            );
                                                        })
                                                    ) : (
                                                        <option>Loading states...</option>
                                                    )}
                                                </select>
                                            </div>
                                        )}
                                        
                                        {/* User Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='User Name' 
                                                type='text' 
                                                className='form-control' 
                                                onChange={handleUserName} 
                                                value={userNameValue} 
                                                maxLength={50}
                                                autoComplete="off"
                                            />
                                        </div>
                                        
                                        {/* Mobile Number */}
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                              Mobile No.
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="mobilenumber"
                                              required
                                              placeholder="Mobile No."
                                              onChange={handleMobileNumber}
                                              value={mobileValue}
                                              onKeyUp={validateMobile}
                                              maxLength="10"

                                            />
                                        </div>
                                        
                                        {/* Designation */}
                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                              Designation
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="Designation"
                                              required
                                              className="form-select"
                                              onChange={(e) => setDesignationValue(e.target.value)}
                                              value={designationValue}
                                            >
                                              <option defaultValue>Choose...</option>
                                              {designationData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.desigCode}>
                                                    {item.desigName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                        </div>
                                        
                                        {/* Email */}
                                        <div className='col-md-4'>
                                            <label className="form-label">Email Id:</label><label style={{color : "red"}}>*</label>
                                           <input placeholder='Email Id' type='text' id="emailid" className='form-control' onChange={(e) => setEmailValue(e.target.value)} value={emailValue} onKeyUp={validateEmail} maxLength={50} readOnly={state ? true : false}/>
                                        </div>
                                        
                                        {/* Gender */}
                                        <div className="col-md-4">
                                            <div className="col-md-12">
                                              <label htmlFor="gender" className="form-label">
                                                Gender
                                              </label><label style={{color : "red"}}>*</label>
                                            </div>
                                            <div className="col-md-12">
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("M");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio1"
                                                  value="male"
                                                  checked={gender === "M"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio1"
                                                >
                                                  Male
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("F");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio2"
                                                  value="female"
                                                  checked={gender === "F"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio2"
                                                >
                                                  Female
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("T");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio3"
                                                  value="transgender"
                                                  checked={gender === "T"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio3"
                                                >
                                                  Other
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                    </div>
                                    
                                    {/* Action Buttons */}
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                        {state ? (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Update User
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={() => {
                                              console.log("Create User button clicked");
                                              ValidateAddUser();
                                            }}
                                          >
                                            Create User
                                          </button>
                                        )}

                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() => navigate("/MNT/UsrlistMnT")}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <AdminFooterNew /> 
        </>
    );
}


export default AdmLogin